import { render } from "./VCta.vue?vue&type=template&id=f7e488ec"
import script from "./VCta.vue?vue&type=script&lang=ts"
export * from "./VCta.vue?vue&type=script&lang=ts"

import "./VCta.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script